// Se registró con aprobación (decisión D48): ve el catálogo pero todavía no puede pedir. Franja arriba de todas las
// pantallas hasta que la distribuidora lo apruebe (el perfil se vuelve a traer al volver a la app).
import { Icono } from '@reparto/ui';
import { useMarca } from '../datos/marca';

export function AvisoEnRevision() {
  const nombre = useMarca((s) => s.marca?.nombre) ?? 'la distribuidora';
  return (
    <div role="status" className="seguro-arriba bg-amber-100 text-amber-950">
      <p className="mx-auto flex max-w-2xl items-start gap-2 px-4 py-2.5 text-[15px] leading-snug">
        <Icono nombre="hourglass_top" tamano={20} className="mt-px shrink-0" />
        <span>
          <b>Tu cuenta está en revisión.</b> Ya podés ver los productos; vas a poder pedir apenas {nombre} la apruebe.
        </span>
      </p>
    </div>
  );
}
